export const useTripLike = () => {
  const BaseUrl = inject("BaseUrl") as string;

  const likeTrip = async (tripId: number) => {
    try {
      const { data } = await useAuthFetch<{
        trip_id: number;
        likes_count: number;
        liked: boolean;
      }>(`${BaseUrl}/trips/${tripId}/like`, {
        method: "POST",
      });

      const responseData = data.value?.data || data.value;
      return {
        success: true,
        tripId: responseData?.trip_id || tripId,
        likesCount: responseData?.likes_count || 0,
        isLiked: responseData?.liked ?? true,
      };
    } catch (error) {
      console.error("Error liking trip:", error);
      return {
        success: false,
        error: error instanceof Error ? error.message : "Failed to like trip",
      };
    }
  };

  const unlikeTrip = async (tripId: number) => {
    try {
      const { data } = await useAuthFetch<{
        trip_id: number;
        likes_count: number;
        liked: boolean;
      }>(`${BaseUrl}/trips/${tripId}/like`, {
        method: "DELETE",
      });

      const responseData = data.value?.data || data.value;
      return {
        success: true,
        tripId: responseData?.trip_id || tripId,
        likesCount: responseData?.likes_count || 0,
        isLiked: responseData?.liked ?? false,
      };
    } catch (error) {
      console.error("Error unliking trip:", error);
      return {
        success: false,
        error: error instanceof Error ? error.message : "Failed to unlike trip",
      };
    }
  };

  return {
    likeTrip,
    unlikeTrip,
  };
};

